import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../../api/api_client';
import { loadingSlice } from './loading';

export const defaultGameState = {
    outcome: '',
    gameData: '',
    game: '',
};

// REDUCERS
// basic actions that affect this object only

const getGameReducer = (state, action) => {

    let outcome = action.payload.outcome;
    let gameData = action.payload.gameData;
    const location = action.payload.location;

    outcome = {
                    ...outcome,
                    gameResult: Array.isArray(outcome.gameResult) ? outcome.gameResult[0] : outcome.gameResult,
                    collectedProperties: Array.isArray(outcome.collectedProperties) ? outcome.collectedProperties[0] : outcome.collectedProperties
                };

    let url = `${location}/monopoly/animations/?outcome=${Buffer.from(JSON.stringify(outcome)).toString('base64')}`;

    if (gameData !== null) {
        url = url.concat(`&gamedata=${Buffer.from(JSON.stringify(gameData)).toString('base64')}`);
    }

    return {
        outcome: outcome,
        gameData: gameData,
        game: url
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultGameState,
    };
};

const setEntryFlashGameFlagReducer = (state, action) => {
    return {
        ...defaultGameState,
    };
};

export const gameSlice = createSlice({
    name: 'game',
    initialState: defaultGameState,
    reducers: {
        getGame: getGameReducer,
        reset: resetReducer,
        setEntryFlashGameFlag: setEntryFlashGameFlagReducer,
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getGame = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    dispatch(gameSlice.actions.getGame(payload));
    dispatch(loadingSlice.actions.unsetLoading());
};

const setEntryFlashGameFlag = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.setEntryFlashGameFlag(payload);
    dispatch(gameSlice.actions.setEntryFlashGameFlag(result));
    dispatch(loadingSlice.actions.unsetLoading());
};

//actions that get exported to the views
export const gameActions = dispatch => {
    return {
        getGame: payload => getGame(dispatch, payload),
        reset: payload => dispatch(gameSlice.actions.reset(payload)),
        setEntryFlashGameFlag: payload =>
            setEntryFlashGameFlag(dispatch, payload),
    };
};
